import React from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as EditIcon } from '../images/edit-icon.svg';
import { device } from '../device';
import { StepperContext } from '../contexts/stepperContext';
import closeIcon from '../images/close-icon-blue.svg';
import { ANIMATION_DIRECTION } from '../constants';

const StyledSidebarWrapper = styled.aside`
  height: 100%;
  position: fixed;
  z-index: 110;
  width: 100%;
  transform: translateY(calc(100% - 60px));
  transition: 0.2s ease-in-out transform;
  ${(props) =>
    props.isOpen &&
    css`
      transform: translateY(0);
    `};

  @media ${device.tablet} {
    transform: translateY(0);
    position: static;
    display: flex;
    padding-right: 2%;
    padding-top: 30px;
    padding-bottom: 30px;
    width: 27%;
    min-width: 232px;
    height: auto;
  }
`;

const StyledSidebar = styled.div`
  height: 100%;
  padding: 20px;
  background-color: ${(props) => props.theme.darkBlue};
  @media ${device.tablet} {
    height: auto;
    padding: 60px 20px 20px;
    width: 100%;
  }
`;

const StyledSidebarTitle = styled.div`
  font-weight: bold;
  font-size: 22px;
  line-height: 100%;
  margin-bottom: 14px;
  ${(props) =>
    props.isOpen &&
    css`
      background: url('${closeIcon}') no-repeat center right;
    `};
  color: ${(props) => props.theme.secondary};
  @media ${device.tablet} {
    background: none;
  }
`;

const StyledItems = styled.div`
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 5px;
  overflow-x: hidden;
  width: auto;
  height: calc(100vh - 230px);

  @media ${device.minHeight} and ${device.tablet} {
    height: calc(100vh - 230px);
  }
`;

const StyledEditableItem = styled.button`
  border: none;
  background: unset;
  border-bottom: 1px solid ${(props) => props.theme.red};
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding: 16px 0;
  cursor: pointer;
`;

const StyledEditableItemText = styled.div`
  font-size: 16px;
  line-height: 20px;
  width: 90%;
  color: ${(props) => props.theme.white};
  text-align: left;
  display: flex;
  flex-direction: column;
`;

const EditableItem = function ({ children, onClick }) {
  return (
    <StyledEditableItem onClick={onClick}>
      <StyledEditableItemText>{children}</StyledEditableItemText>
      <EditIcon />
    </StyledEditableItem>
  );
};

const Sidebar = function () {
  const [isOpen, setIsOpen] = React.useState(false);
  const { state, dispatch } = React.useContext(StepperContext);
  const {
    currentPage,
    printerConfiguration: { printerType, printerParts, clientValue },
  } = state;

  return (
    <StyledSidebarWrapper isOpen={isOpen}>
      <StyledSidebar>
        <StyledSidebarTitle
          isOpen={isOpen}
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          YOUR SELECTIONS
        </StyledSidebarTitle>
        <StyledItems>
          <EditableItem
            onClick={() => {
              setIsOpen(!isOpen);
              dispatch({ type: 'setParts', printerParts: null });
              dispatch({
                type: 'setCurrentPage',
                currentPage: 1,
                animationDirection:
                  currentPage > 1
                    ? ANIMATION_DIRECTION.BACKWARD
                    : ANIMATION_DIRECTION.FORWARD,
              });
            }}
          >
            <strong>PRINTER :</strong>
            <div>{printerType}</div>
          </EditableItem>

          {printerParts ? (
            <EditableItem
              onClick={() => {
                setIsOpen(!isOpen);
                dispatch({ type: 'setClientValue', clientValue: '' });
                dispatch({
                  type: 'setCurrentPage',
                  currentPage: 2,
                  animationDirection:
                    currentPage > 2
                      ? ANIMATION_DIRECTION.BACKWARD
                      : ANIMATION_DIRECTION.FORWARD,
                });
              }}
            >
              {' '}
              <strong>PRINTER PARTS :</strong>
              {printerParts?.partName ? (
                <div>{printerParts?.partName}</div>
              ) : (
                ''
              )}
            </EditableItem>
          ) : (
            ''
          )}

          {clientValue ? (
            <EditableItem
              onClick={() => {
                setIsOpen(!isOpen);
                dispatch({
                  type: 'setCurrentPage',
                  currentPage: 3,
                  animationDirection:
                    currentPage > 3
                      ? ANIMATION_DIRECTION.BACKWARD
                      : ANIMATION_DIRECTION.FORWARD,
                });
              }}
            >
              {' '}
              <strong>QUANTITY AND LABOR COST :</strong>
              {clientValue ? (
                <div>{`Cost: $${parseFloat(clientValue).toFixed(2)}`}</div>
              ) : (
                ''
              )}
            </EditableItem>
          ) : (
            ''
          )}
        </StyledItems>
      </StyledSidebar>
    </StyledSidebarWrapper>
  );
};

export default Sidebar;
